import type { ComponentProps } from "react"
import { cn } from "@/lib/utils.js"

export function Input({ className, ...props }: ComponentProps<"input">) {
  return (
    <input
      className={cn(
        "h-8 w-full rounded-md border border-input bg-card px-3 text-sm transition-colors placeholder:text-muted-foreground/70 hover:border-ring/40 focus:border-ring",
        className,
      )}
      {...props}
    />
  )
}

/** The same control, tall: for the one thing a person writes in sentences — an override's note. */
export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(
        "min-h-20 w-full rounded-md border border-input bg-card px-3 py-1.5 text-sm transition-colors placeholder:text-muted-foreground/70 hover:border-ring/40 focus:border-ring",
        className,
      )}
      {...props}
    />
  )
}

/**
 * A form label: sentence case, full contrast. The 11px uppercase label voice
 * belongs to table headers, not to things somebody has to fill in.
 *
 * Callers bind it with `htmlFor`, or wrap the control — a rule looking for a
 * nested control cannot see across a component boundary, so the pairing is
 * checked at the call site instead.
 */
export function Label({ className, ...props }: ComponentProps<"label">) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: the control is supplied by the caller
    <label className={cn("text-[13px] font-medium text-foreground", className)} {...props} />
  )
}
